import { mapGetters } from 'vuex'
import { MethodDescriptor } from '@/common/model/PaymentMethod'
import FormError from '@/host/components/mixins/FormError'

export default {
  mixins: [FormError],
  computed: {
    ...mapGetters(['effectivePreferredMethods']),
    // Check if the error has no metadata attached
    isRegularError() {
      // The error has no payment method attached
      const paymentMethod = this.error?.paymentMethod
      if (!paymentMethod) return false
      return !MethodDescriptor.fromString(paymentMethod).metadata
    },
    isPreferredMethodError() {
      return this.effectivePreferredMethods.includes(this.error?.paymentMethod)
    }
  }
}
